<script setup lang="ts">
defineProps<{
  icon?: string
  size?: number
  vertical?: boolean
  gap?: boolean
}>()
</script>

<template>
  <span class="m-icon" :class="{ vertical, gap }">
    <slot name="start" />
    <n-icon v-if="icon" :size="size" :class="icon" class="m-icon__icon" />
    <slot />
  </span>
</template>

<style lang="scss" scoped>
.m-icon {
  display: flex;
  align-items: center;
  &.vertical {
    flex-direction: column;
  }
  &.gap &__icon {
    margin-right: 4px;
  }
}
</style>
